import clsx from 'clsx';

import { makeStyles } from '@gogame/ui/styles';

const useStyles = makeStyles(() => ({
  root: {
    '& img': {
      transition: 'transform 1s ease-in-out',
    },
    '&:hover': {
      '& img': {
        transform: (props) =>
          props.hoverScaleImg ? `scale(${props.hoverScaleImg})` : 'none',
      },
    },
  },
}));

export default (BaseComponent) =>
  ({ hoverScaleImg = false, className, children, ...props }) => {
    if (hoverScaleImg) {
      const classes = useStyles({ hoverScaleImg });
      return (
        <BaseComponent {...props} className={clsx(classes.root, className)}>
          {children}
        </BaseComponent>
      );
    } else {
      return (
        <BaseComponent {...props} className={className}>
          {children}
        </BaseComponent>
      );
    }
  };
